import styled from 'styled-components'
import { colors } from '../../theme'

/**
 * Painel de comunicado da troca de marca, ao lado do cartao de login.
 *
 * Mesma superficie do cartao (`colors.login` e `colors.surface` sao o mesmo
 * #1e2939), separado dele pelo gap sobre o fundo `grey100` — os dois leem como
 * dois cartoes, nao como um bloco so.
 */
export const Painel = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 420px;
  max-width: 100%;
  padding: 40px;
  border-radius: 20px;
  background-color: ${colors.surface};
  box-shadow: 0 18px 48px ${colors.overlay};
  color: ${colors.grey800};
`

/* Pilula de destaque, no idioma dos chips de status do app: fundo verde
   translucido com texto claro por cima. O fundo efetivo nao e `surface`, e a
   composicao de lightGreen sobre ela (~#204348); contra secondaryText da ~7,3:1,
   acima de AAA. */
export const Selo = styled.span`
  align-self: flex-start;
  padding: 4px 12px;
  border-radius: 999px;
  background-color: ${colors.lightGreen};
  color: ${colors.secondaryText};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`

/* Titulo e chamada andam juntos, com respiro menor que o do painel — mesmo
   padrao do `TituloGrupo` das telas de autenticacao. Evita margem negativa
   acoplada ao gap do painel. */
export const GrupoTitulo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Titulo = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
  color: ${colors.white};

  strong {
    font-weight: 600;
    color: ${colors.primaryText};
  }
`

export const Chamada = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${colors.secondaryText};
`

export const Paragrafo = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
`

/**
 * O endereco novo e a unica parte acionavel do aviso, entao ganha moldura
 * propria. Continua sendo um link de verdade: quem chegar pelo dominio antigo
 * (que segue no ar) usa o aviso para migrar de fato.
 */
export const BlocoEndereco = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  border: 1px solid ${colors.grey300};
  border-left: 3px solid ${colors.primaryText};
  border-radius: 10px;
  background-color: ${colors.grey50};
`

export const RotuloEndereco = styled.span`
  font-size: 12px;
  line-height: 1.5;
  color: ${colors.grey700};
`

export const LinkEndereco = styled.a`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.primaryText};
  text-decoration: none;
  /* O endereco nao pode estourar o painel em telas estreitas. */
  overflow-wrap: anywhere;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`

export const Fechamento = styled.p`
  margin: 0;
  padding-top: 14px;
  border-top: 1px solid ${colors.grey300};
  font-size: 13px;
  font-weight: 500;
  line-height: 1.6;
  color: ${colors.white};
`
